import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useMode } from "@/context/ModeContext";
import { useUserRole } from "../hooks/useUserRole";
import { getFinancialScope } from "../utils/accessPolicy";
import { InitialLoadScreen } from "./InitialLoadScreen";
import { toast } from "sonner";
import PropTypes from "prop-types";

export default function FinancialRoute({ children }) {
  const { activeMode } = useMode();
  const { memberships, isReceptionistOnly, isLoading } = useUserRole();
  const scope = getFinancialScope(activeMode, memberships, isReceptionistOnly);

  useEffect(() => {
    if (!isLoading && !scope.canAccessFinancials) {
      toast.error("Reports are unavailable in the selected clinic mode");
    }
  }, [isLoading, scope.canAccessFinancials]);

  if (isLoading) return <InitialLoadScreen />;
  return scope.canAccessFinancials ? children : <Navigate to="/" replace />;
}

FinancialRoute.propTypes = {
  children: PropTypes.node,
};
